module.exports = __webpack_public_path__ + "static/img/T-1.571cb76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/T-1.png
// module id = nc8I
// module chunks = 1